module.exports = __webpack_public_path__ + "static/media/envelope.fc2dbf01.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/envelope.svg
// module id = 1813
// module chunks = 0